import { createClient } from 'laboratory-lib';
import experiments from '../../experiments.yaml';
import portalIdParser from 'PortalIdParser';
const treatmentsClient = createClient({
  name: 'growth-payments-lib-laboratory',
  /*
  We don't want to quick fetch the experiment treatments because we don't want to rely on the consuming
  app's experiments.yaml config to load experiments. Instead, we want the library to have full control
  over the experiments it's defining. This does have a slight cost of an extra request but it's a more scalable
  solution so we don't have to define the experiment config in the experiments.yaml file of every consuming app.
  Related docs: https://product.hubteam.com/docs/laboratory/guides/technical-stuff/frontend/coding-a-frontend-experiment.html#using-with-quick-fetch-pre-flight-requests
  */
  // quickFetchLabel: 'experiment-treatments',
  identifiers: {
    portalId: portalIdParser.get()
  },
  experiments: experiments,
  /*
  There seems to be a caching issue going on with ATs where our manual overrides
  were not actually taking effect. Setting `mode` to "network-only" tells laboratory-lib
  to ignore the cache and always query the backend for experiment data. This isn't ideal
  because it can in theory slow down page load times so we should look into removing this
  flag if there's not an experiment running that causes issues.
  */
  mode: 'network-only'
});
export default treatmentsClient;